<template>
	<!-- 门店资质信息组件 -->
	<div class="flex-component">
		<div class="flex-title">
			<div class="flex-layout text-left">
				<p>门店资质</p>
			</div>
		</div>
		<div class="flex-cont">
			<div>
				<el-row class="basic-row" v-if="state.FirstOrderAuthStatus && state.FirstOrderAuthStatus === '2'">
					认证状态：<span class="col-success">认证通过</span>
				</el-row>
				<el-row class="basic-row" v-else>
					认证状态：<span class="col-red">未认证</span>
				</el-row>
			</div>
			<div>
				<el-row class="basic-row" v-if="state.FirstOrderStatus && state.FirstOrderStatus === '1'">
					审核状态：<span class="col-success">审核中</span>
				</el-row>
				<el-row class="basic-row" v-else-if="state.FirstOrderStatus && state.FirstOrderStatus === '2'">
					审核状态：<span class="col-success">审核通过</span>
				</el-row>
				<el-row class="basic-row" v-else-if="state.FirstOrderStatus && state.FirstOrderStatus === '3'">
					审核状态：<span class="col-red">审核失败</span>
				</el-row>
				<el-row class="basic-row" v-else-if="state.FirstOrderStatus && state.FirstOrderStatus === '4'">
					审核状态：<span class="col-red">未提交</span>
				</el-row>
				<el-row class="basic-row">
					审核意见：<span>{{ state.FirstOrderStatusReason === null ? '-' : state.FirstOrderStatusReason }}</span>
				</el-row>
			</div>
		</div>
		<div class="flex-cont">
			<label>上传说明：</label>
			<p>1、上传的图片清晰、完整。</p>
			<p>2、录入的证件号与有效期与证件完全一致。</p>
			<p>3、如有变更记录，请上传相关证件的变更记录。</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
	  storesData: {
	    type: Object,
	    default: () => {}
	  }
	},
	data() {
		return {
			// 数据状态
			state: {},
		};
	},
	watch: {
		// 监听参数变化
		storesData: {
			handler(newData, oldData) {
				if (newData.storesData === undefined) {
					return
				}
				// 渲染数据
				this.updateData(newData);
			},
			deep: true,
			immediate: false
		}
	},
	created() {},
	mounted() {},
	methods: {
		/*
		 * 渲染数据
		 */
		updateData(data) {
			let obj = JSON.parse(data.storesData)
			// 赋值本地状态
			this.state = {
				FirstOrderStatus: obj.FirstOrderStatus ,//审核状态
				FirstOrderStatusReason: obj.FirstOrderStatusReason,//状态对应原因
				FirstOrderAuthStatus: obj.FirstOrderAuthStatus //认证状态
			}
		}
	}
};
</script>

<style scoped lang="less">
	/deep/.flex-layout {
		flex: 0 0 91%;
	}
	/deep/.onSubmitTag {
		padding: 0;
	}
	/deep/.basic-row{
		font-size: 14px;
		padding:0 0 20px 0;
		display: block;
		/deep/.onSubmit {
			background-color: #0F6EEA;
			width: 121px;
			height: 36px;
			line-height: 36px;
			padding: 0;
			margin: 0 auto;
			text-align: center;
			color: #FFFFFF;
			border-radius: 2px;
		}
		/deep/.col-red {
			color: #FF3939;
		}
		/deep/.col-blue {
			color: #0F6EEA;
		}
		/deep/.col-gray {
			background-color: #D5D5D5;
		}
		/deep/.col-success {
			color: #67C23A;
		}
	}
</style>
